import { render, staticRenderFns } from "./TopOnlyLayout.vue?vue&type=template&id=59508fa8&"
import script from "./TopOnlyLayout.vue?vue&type=script&lang=js&"
export * from "./TopOnlyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports